import { ActionsWidget } from "../components/widgets/actions/actions.widget";

export const APP_WIDGETS = [
    ActionsWidget
];